import { render } from "./_ChatPolicy.vue?vue&type=template&id=3e609d8f"
import script from "./_ChatPolicy.vue?vue&type=script&lang=js"
export * from "./_ChatPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__